// Function to create and show the notification (keep this for other uses if needed)
function showNotification(message, type="success") {
  // Create the notification element
  const notification = document.createElement('div');
  notification.className = 'cart-alert';
  notification.classList.add(type);
  notification.textContent = message;
  // Append the notification to the body
  document.body.appendChild(notification);
  // Trigger the slide-up animation
  setTimeout(() => {
    notification.style.bottom = '20px';
  }, 10); // Small delay to ensure the element is added to the DOM
  // Slide down and remove the notification after 3 seconds
  setTimeout(() => {
    notification.style.bottom = '-100%';
    // Remove the element after the slide-down animation completes
    notification.addEventListener('transitionend', () => {
      notification.remove();
    }, { once: true });
  }, 3000); // 3 seconds delay
}

async function updateCartIcon() {
  try {
    // Fetch the latest cart data
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    
    const cart = await response.json();
    
    // Update cart icon count
    const cartIcon = document.getElementById('cart-icon');
    const countBubble = cartIcon.querySelector('.cart-count-bubble');
    
    if (cart.item_count > 0) {
      if (!countBubble) {
        const newBubble = document.createElement('div');
        newBubble.className = 'cart-count-bubble';
        newBubble.innerHTML = '<span>' + cart.item_count + '</span>';
        cartIcon.appendChild(newBubble);
      } else {
        countBubble.querySelector('span').textContent = cart.item_count;
      }
    } else if (countBubble) {
      countBubble.remove();
    }
    
    return cart; // Return cart data for further use
  } catch (error) {
    console.error('Error updating cart icon:', error);
  }
}

// Function to open cart offcanvas
function openCartOffcanvas() {
  const offcanvasElement = document.getElementById('cart-offcanvas');
  if (offcanvasElement) {
    const offcanvas = new bootstrap.Offcanvas(offcanvasElement);
    offcanvas.show();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('change', async (event) => {
    if (event.target.tagName === 'SELECT') {
      const productForm = event.target.closest('form');
      const productId = productForm.dataset.productId;
      if (productId) {
        const variantId = productForm.querySelector(`#product-select-${productId}`);
        variantId.value = event.target.value;
      }
    }
  });
  
  document.addEventListener('submit', async (event) => {
    if (event.target.classList.contains('product-form')) {
      event.preventDefault();
  
      const form = event.target;
      const formData = new FormData(form);
  
      // Get the submit button and disable it
      const submitButton = form.querySelector('button[type="submit"]');
      submitButton.disabled = true;
  
      // Extract the variant ID and quantity from the form
      const variantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;
  
      // Prepare the data for the Shopify Cart API
      const cartData = {
        items: [
          {
            id: variantId,
            quantity: parseInt(quantity, 10), // Ensure quantity is a number
          },
        ],
      };
  
      try {
        // Make a POST request to the Shopify Cart API
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(cartData),
        });
  
        if (!response.ok) {
          throw new Error('Failed to add product to cart');
        }
  
        const result = await response.json();
        
        // Update Cart Icon and get updated cart data
        const updatedCart = await updateCartIcon();
        
        // Update the cart offcanvas content if updateCartOffcanvas function exists
        if (typeof updateCartOffcanvas === 'function' && updatedCart) {
          await updateCartOffcanvas(updatedCart);
        }
        
        // Open the cart offcanvas instead of showing notification
        openCartOffcanvas();
  
        // Re-enable the submit button
        submitButton.disabled = false;
      } catch (error) {
        console.error('Error adding product to cart:', error);
        showNotification('Error adding product to cart', 'error');
  
        // Re-enable the submit button in case of error
        submitButton.disabled = false;
      }
    }
  });
});